module.exports = __webpack_public_path__ + "static/media/slick.f97e3bbf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/slick.svg
// module id = 342
// module chunks = 0